import 'waypoints/lib/noframework.waypoints.min';
import 'waypoints/lib/shortcuts/inview.min';

/**
 * Listen for window changes and active elements with the "fade" class that are visible (that haven't already been activated)
 *
 * @constructor
 */
const FadeScroller = () => {
    // Check the location of each desired element
    let elements = document.querySelectorAll('.fade');
    (elements).forEach(function(element) {
        new Waypoint({
            element: element,
            handler: function() {
                if ((this.element).style.opacity !== '1') {
                    (this.element).style.opacity = 1;
                    this.destroy();
                }
            },
            offset: '95%'
        })
    });
};

/**
 * Listen for window changes and find elements that are considered "active" on the Model's page
 *
 * @constructor
 */
const ActiveHeader = () => {
    // Check the location of each desired element
    let elements = document.querySelectorAll("[data-model-reference]");
    if (elements.length === 0) {return;}

    // Page sections
    (elements).forEach(function(element) {
        new Waypoint({
            element: element,
            handler: function() {
                // Make active
                let triggeredElement = this.element;
                if (!(triggeredElement).classList.contains('active')) {
                    (triggeredElement).classList.add('active');

                    // Deactivate all others
                    let elements = document.querySelectorAll("[data-model-reference]");
                    (elements).forEach(function(other_element) {
                        if (other_element !== (triggeredElement) && other_element.classList.contains('active')) {
                            other_element.classList.remove('active');
                        }
                    });

                    // Make Right-hand links active
                    let links = document.querySelectorAll('.with-line-black');
                    (links).forEach(function(link) {
                        if (link.getAttribute('id') === triggeredElement.dataset.modelReference) {
                            link.classList.add('active');
                        }
                        else if (link.classList.contains('active')) {
                            link.classList.remove('active');
                        }
                    });
                }
            }
        });
    });
};

/**
 * Listen for Builder's Options/Details panels being scrollable and show custom scrollbar
 * @constructor
 */
const BuilderScroller = () => {
    let optionsPanel = document.getElementById("builder-options");
    let detailsPanel = document.getElementById("builder-details");
    if (optionsPanel === null) {return;}
    else if (window.innerWidth <= 1099) {
        optionsPanel.onscroll = null;
        detailsPanel.onscroll = null;
    }

    if (optionsPanel.clientHeight < optionsPanel.scrollHeight) {
        if (optionsPanel.scrollHeight - optionsPanel.scrollTop === optionsPanel.clientHeight) {
            // Hide custom div
            document.getElementById('options-scroller').style.opacity = '0';
        } else {
            // Show custom div
            document.getElementById('options-scroller').style.opacity = '1';
        }

        // setup listener
        optionsPanel.onscroll = () => {BuilderScroller()}
    } else {
        // Remove any listener for Options panel
        document.getElementById('options-scroller').style.opacity = '0';
        optionsPanel.onscroll = null;
    }

    if (detailsPanel.clientHeight < detailsPanel.scrollHeight) {
        if (detailsPanel.scrollHeight - detailsPanel.scrollTop === detailsPanel.clientHeight) {
            // Hide custom div
            document.getElementById('details-scroller').style.opacity = '0';
        } else {
            // Show custom div
            document.getElementById('details-scroller').style.opacity = '1';
        }

        // setup listener
        detailsPanel.onscroll = () => {BuilderScroller()}
    } else {
        // Remove any listener for Details panel
        document.getElementById('details-scroller').style.opacity = '0';
        detailsPanel.onscroll = null;
    }
};

// ------------------------------------------------------------------------------------------------------------------ //

/**
 * Lazy Load images with the `data-scroll-lazysrc` attribute whenever they enter the viewport
 */
const scrollLazyLoader = () => {
    let elements = document.querySelectorAll('img[data-scroll-lazysrc]');
    (elements).forEach(function(element) {
        element.src = '';

        new Waypoint.Inview({
            element: element,
            entered: function() {
                // Reload image by actually setting it's source to the lazysrc URL only when scrolled into view
                // (for elements under the fold)
                let triggeredElement = this.element;
                triggeredElement.src = triggeredElement.dataset.scrollLazysrc;
                triggeredElement.removeAttribute('data-scroll-lazysrc');
                this.destroy();
            }
        });
    });
};

/**
 * Shimmer load images with special animations
 *
 * @param window
 */
const shimmerLoader = (window) => {
    // Run shimmer loading animation first
    let shimmerElements = document.querySelectorAll('img[data-shimmer-dimensions]');
    (shimmerElements).forEach(function(element) {

        // Add shimmer animation
        let dimensions = (element.dataset.shimmerDimensions).split('x');
        element.style.width = dimensions[0]+'px';
        element.style.height = dimensions[1]+'px';
        element.classList.add('shimmer-loading');

        new Waypoint({
            element: element,
            handler: function() {
                // Make active
                let triggeredElement = this.element;
                if (!triggeredElement.hasAttribute('data-shimmer-dimensions')) {return;}

                let bounding = triggeredElement.getBoundingClientRect();
                if (
                    bounding.top >= 0 && bounding.bottom <= window.innerHeight &&
                    triggeredElement.dataset.shimmerLazysrc !== undefined
                ) {
                    // Load image
                    triggeredElement.src = triggeredElement.dataset.shimmerLazysrc;
                    triggeredElement.removeAttribute('data-shimmer-lazysrc');
                    triggeredElement.removeAttribute('data-shimmer-dimensions');
                    triggeredElement.classList.remove('shimmer-loading');

                    // Reset dimensions
                    element.style.width = 'initial';
                    element.style.height = 'initial';

                    if (triggeredElement.alt === '' || triggeredElement.alt === null) {
                        triggeredElement.alt = triggeredElement.dataset.lazysrc;
                    }

                    this.destroy();
                }
            },
            offset: '90%'
        });
    });
};

// ------------------------------------------------------------------------------------------------------------------ //

/**
 * All methods that need to be called several times on window state changes
 *
 * @param window
 * @param refresh
 */
export const run = (window, refresh = false) => {
    if (refresh) {
        Waypoint.refreshAll(); return;
    }

    // destroy all previous Waypoints on new page refresh
    Waypoint.destroyAll();

    // Loaders
    scrollLazyLoader();
    shimmerLoader(window);

    // Fades and Headers
    FadeScroller();
    ActiveHeader();
    BuilderScroller();
};
